export default "__VITE_ASSET__B8DOy6KX__"